import { NewRadio } from '../../PIM/common';
import type { BombiixCellRendererParams, BombiixRow, BombiixRowId } from '../types';

interface RadioCellExtras {
  getGroupName?: (row: BombiixRow) => string | undefined;
  getChecked?: (row: BombiixRow) => boolean;
}

type RadioCellProps = BombiixCellRendererParams & RadioCellExtras;

/**
 * Single-select radio cell backed by NewRadio. By default all rows in one grid
 * share the same `groupName` so AG Grid's value model holds the selected row id
 * on every row's field. Per-row resolvers `getGroupName(row)`/`getChecked(row)`
 * override the shared fallbacks for grids with many independent groups.
 */
function RadioCell(params: RadioCellProps) {
  const { data, colDef, onRowChange, getRowId, groupName, selectedRowId, getGroupName, getChecked, disabled } = params;
  const rowId: BombiixRowId | undefined = getRowId && data ? getRowId(data) : (data as { id?: BombiixRowId } | undefined)?.id;
  const field = colDef?.field;
  const name = typeof getGroupName === 'function' && data ? getGroupName(data) : groupName;
  const checked = typeof getChecked === 'function' && data ? getChecked(data) : selectedRowId === rowId;

  return (
    <label className="cag-radio">
      <NewRadio
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={() => {
          if (rowId !== undefined && field) onRowChange?.(rowId, field, rowId);
        }}
      />
    </label>
  );
}

export default RadioCell;
